module.exports = __webpack_public_path__ + "media/images/gifts/autonomy/sug_autonomia_5-a6a78421f288046ea5e75bb93659caf1.jpg";